<template>
    <div class="dingdan">
<!--        <breadcrumb :routerList="[{to:'/dingd/dingdwxlist',title:'订单管理'},{title:'发货计划'}]" v-if="firstPageFlag!=1"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                	<div class="h-thirdColumn w-newColumn">
                		<el-form-item label="发货计划编码" prop="id" style="width: 50%;">
                		    <el-input v-model="formInline.id" placeholder="多订单模糊查询请用逗号隔开"></el-input>
                		</el-form-item>
                        <el-form-item label="订单号" prop="sapCode" style="width: 50%;">
                            <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用逗号隔开"></el-input>
                        </el-form-item>
                        <el-form-item label="国家" prop="country" style="width: 50%;">
                            <el-input v-model="formInline.country" placeholder="请输入国家名称"></el-input>
                        </el-form-item>
                	</div>
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="通知送货时间" prop="cdatebegin" style="width: 50%;">
                            <el-date-picker
                                    v-model="formInline.cdatebegin"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                            <span class="w-time-to">至</span>
                            <el-date-picker
                                    v-model="formInline.cdateend"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="要求送货时间" prop="requiredDeliveryTimeBegin" style="width: 50%;">
                            <el-date-picker
                                    v-model="formInline.requiredDeliveryTimeBegin"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                            <span class="w-time-to">至</span>
                            <el-date-picker
                                    v-model="formInline.requiredDeliveryTimeEnd"
                                    clearable
                                    type="date"
                                    value-format="yyyy-MM-dd" >
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </el-form>
				<div class="l-screenBox">
					<div class="l-retrieval">
						<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
						<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
						</el-button>
						<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
						           @click="imgfalse3">
						    新建发货计划
						</el-button>
					</div>
				</div>
            </div>
        </div>
        <div class="h-table h-mrt30">
            <el-table
                    ref="ddtable"
                    :data="tableData"
                    stripe
            		border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
            		max-height="510"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="selection"
                        fixed
                        width="55">
                </el-table-column>
                <el-table-column
                        type="index"
            			fixed
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="发货计划编码"
            			fixed
            			:show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="orderNum"
                        label="订单号"
                        fixed
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="qyname"
                        label="区域"
                        fixed
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="country"
                        label="国家"
                        fixed
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="despatchOrderTime"
                        label="通知送货时间"
            			:show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="shipmentUnit"-->
                        <!--label="发货单位"-->
                        <!--:show-overflow-tooltip="true"-->
                        <!--width="100">-->
                <!--</el-table-column>-->
                <!--<el-table-column-->
                        <!--prop="sparePart"-->
                        <!--label="备件"-->
                        <!--:show-overflow-tooltip="true"-->
                        <!--width="180">-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="count"
                        label="备件数量"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="产品数量"
                        width="100"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="fhWay"
                        label="送货方式"
                        :show-overflow-tooltip="true"
                        width="140">
                    <template scope="scope">
                        <div style="text-align: left;">
                            <span v-if="scope.row.fhWay==='1'">拼箱</span>
                            <span v-else-if="scope.row.fhWay==='2'">整柜</span>
                            <span v-else-if="scope.row.fhWay==='3'">快递</span>
                            <span v-else-if="scope.row.fhWay==='4'">自提</span>
                            <span v-else-if="scope.row.fhWay==='5'">空运</span>
                            <span v-else-if="scope.row.fhWay==='6'">异地</span>
                            <span v-else-if="scope.row.fhWay==='7'">直发</span>
                            <span v-else></span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderPriceRbm"
                        label="人民币总价"
                        width="120"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="allhjtiji"
                        label="总立方数"
                        width="120"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="afterSalesNetwork"-->
                        <!--label="售后配送网点"-->
            			<!--:show-overflow-tooltip="true"-->
                        <!--width="100">-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="requiredDeliveryTime"
                        label="要求送货时间"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="cdate"-->
                        <!--label="创建时间"-->
                        <!--width="160">-->
                <!--</el-table-column>-->
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <di style="text-align: left;">
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="updateDetail(scope.row)">编辑
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="handelDetail(scope.row)">查看
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="exportDtExcel(scope.row)">导出
                                </el-button>
                            </di>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
            <pagination :page="formInline" @query="query"/>
            <div style="display:flex;align-items: center;margin-left: 20px">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportExcel()">批量导出
                </el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import updownfile from '../../utils/updownfile';
    import ss from '../../api/SystemService'
    export default {
        data() {
            return {
				// 展开折叠筛选
				wxCreditFlag:false,
				creditFlagModel:{
					sapCode:"",
					flag:""
				},
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                adminFlag:false,
                //撤回
                chehuidialogFormVisible: false,
                //导入Excel
                uploaddownexcelflag: false,

                fjFlag: null,
                fjCode: null,
                id: null,
                fhStatus: null,
                refid: null,
                reftype: null,
                showFujian: null,

                instid: null,
                showhistory: null,

                imgflag3: false,
                orderTypeList: [],
                orderCategory1AllList:[],
                orderCategory1List:[],

                tableData: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                //表单
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    id:null,
                    sapCode:null,
                    cdatebegin:null,
                    cdateend:null,
                    country:null,
                    requiredDeliveryTimeBegin:null,
                    requiredDeliveryTimeEnd:null
                },

                customsCode: null,
                billCode: null,
                billDate: null,

                spanArr: [],
                //作废原因
                zfyydialogFormVisible:false,
                zuofeiyy:{
                    id:null,
                    yy:null,
                    bz:null,
                    type:null,
					orderStatus:null,
                },
                ids:[],
                tableSelectedList:[],
                shipToAreaCodeList:[],
                dqcodeList:[],

            }
        },

        created() {
            this.query();
            //    项目
            //     this.listPro();

            //获取所属大区列表
            ss.OrderMainService.getDq().then(rd => {
                this.dqcodeList = rd;
                console.log("dqcodeList", this.dqcodeList);
            });

        },
        methods: {
            handleSelectionChange(lists){
                this.ids = [];
                lists.forEach(item => {
                    this.ids.push(item.id)
                })
            },
            imgfalse3() {
                this.$router.push({path: '/dingd/createFhjhOrder'})
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                ss.OrderMainService.selectFhPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    //console.log('tableData', this.tableData);
                    this.formInline.total = rd.total || 0;
                });
            },
            //检索
            handleFilter() {
                this.formInline.pageNum = 1;
                this.query();
            },

            // 重置按钮
            resetData() {
                this.formInline.id = null;
                this.formInline.sapCode=null;
                this.formInline.cdatebegin=null;
                this.formInline.cdateend=null;
                this.formInline.country = null;
                this.formInline.requiredDeliveryTimeBegin=null;
                this.formInline.requiredDeliveryTimeEnd=null;
            },

            // 批量导出f
            // exportExcel() {
            //     let data = {};
            //     data.id = this.ids.join(",");
            //     updownfile.down("/api/swyl/v1/dingdmain/shipmentSchedule/downloadExcel", data, "post");
            // },
            exportExcel(item){
                if(item){
                    this.ids = [];
                    this.ids.push(item.id)
                }
                let data = {};
                data.id = this.ids.join(",");
                var form = {
                    pageSize: 10,
                        pageNo: 1,
                        total: 0,
                        id:null,
                        sapCode:null,
                        cdatebegin:null,
                        cdateend:null,
                        country:null,
                        requiredDeliveryTimeBegin:null,
                        requiredDeliveryTimeEnd:null
                },
                form = _.clone(this.formInline);
                if(this.ids.length > 0){
                    this.formInline.id = this.ids.join(",");
                }
                ss.OrderMainService.downloadBatchExcel(this.formInline).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `发货计划详情.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
            },
            exportDtExcel(item){
                if(item){
                    this.ids = [];
                    this.ids.push(item.id)
                }
                let data = {};
                data.id = this.ids.join(",");
                ss.OrderMainService.downloadExcel(data).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `发货计划.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
            },
            download (data) {
                if (!data) {
                    return
                }
                let url = window.URL.createObjectURL(new Blob([data.data]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', '供应商名录.xlsx')
                document.body.appendChild(link)
                link.click();
                URL.revokeObjectURL(link.href) // 释放URL 对象
                document.body.removeChild(link)
            },
            handleEdit(row) {
                console.log(row)
                this.toEdit(row.orderCategory, row.orderCategory1, row.id);
                // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
            },
            updateDetail(row) {
                this.$router.push({
                    path: "/dingd/updateFhjhOrder",
                    query: {id: row.id}
                });
            },
            handelDetail(row) {
                this.$router.push({
                    path: "/dingd/checkFhjhOrder",
                    query: {id: row.id}
                });
            },
            //删除订单
            sapDeleteOrder2(row) {
                if (row.status == '10' || row.status == '30') {
                    this.$msg.confirm("确认删除?", () => {
                        ss.OrderMainService.sapDeleteOrder2(row.bid, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.bid
                    this.zfyydialogFormVisible = true;
                }
            },
            handleDelete(row) {

            },
        },

        mounted() {

        },

    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }

</style>
